import { render, staticRenderFns } from "./submit_table.vue?vue&type=template&id=4f147f69"
import script from "./submit_table.vue?vue&type=script&lang=js"
export * from "./submit_table.vue?vue&type=script&lang=js"
import style0 from "./submit_table.vue?vue&type=style&index=0&id=4f147f69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports